import SessionStorage from "sessionstorage";
import axios from "axios";
import {APIHOST, MOMENT_API_DATE_FORMAT} from "@/settings";
import _ from "underscore";
import PrintJs from "print-js";
import $bus from "@/eventbus/global.event.bus";
import * as busEvents from "@/eventbus/events";
import moment from 'moment';
import AmountTextHelper from '@/helpers/amount.text'

class AttorneyService {
    register({
                 shipmentWaybillId,
                 imageFileBase64,
                 number,
                 date,
                 expireDate,
                 customerCompanyName,
                 customerCompanyAddress,
                 proxyName,
                 proxyPosition,
                 proxyPassportSerialNumber,
                 proxyPassportIssuer,
                 proxyPassportIssuerDate,
                 releaserCompanyName,
                 documentNumber,
                 documentDate,
                 items
             }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/RegisterAttorney`, {
            ShipmentWaybillId: shipmentWaybillId,
            ImageFileBase64: imageFileBase64,
            Number: number,
            Date: moment(date).format(MOMENT_API_DATE_FORMAT),
            ExpireDate: moment(expireDate).format(MOMENT_API_DATE_FORMAT),
            CustomerCompanyName: customerCompanyName,
            CustomerCompanyAddress: customerCompanyAddress,
            ProxyName: proxyName,
            ProxyPosition: proxyPosition,
            ProxyPassportSerialNumber: proxyPassportSerialNumber,
            ProxyPassportIssuer: proxyPassportIssuer,
            ProxyPassportIssuerDate: moment(proxyPassportIssuerDate).format(MOMENT_API_DATE_FORMAT),
            ReleaserCompanyName: releaserCompanyName,
            DocumentNumber: documentNumber,
            DocumentDate: moment(documentDate).format(MOMENT_API_DATE_FORMAT),
            Items: _.map(items, i => {
                return {
                    Product: i.product,
                    Measurement: i.measurement,
                    Quantity: i.quantity
                };
            })
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/AttorneyInfo/${id}`, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getAll({skip, limit, sortBy, desc, isActive, contractorInn, q, isSign, number, startDate,endDate}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return new Promise(function (resolve, reject) {
            axios.get(`${APIHOST}/api/CompanyAttorney`, {
                params: {
                    skip: skip ? skip : null,
                    limit: limit ? limit : null,
                    sortBy: typeof sortBy === "string" ? sortBy : "",
                    desc: typeof desc === "boolean" ? desc : false,
                    isActive: isActive ? isActive : null,
                    contractorInn: typeof contractorInn === "string" ? contractorInn : "",
                    q: typeof q === "string" ? q : "",
                    isSign: typeof (isSign) === 'boolean' ? isSign : null,
                    number: typeof number === "string" ? number : "",
                    startCreatedOn: typeof startDate === "string" ? startDate : null,
                    endCreatedOn:typeof endDate === 'string' ? endDate : null
                },
                headers: {
                    'Authorization': `Bearer ${oAuthAccess.access_token}`
                }
            }).then(function (response) {
                resolve(response.data);
            }).then(function (error) {
                reject(error);
            });
        });
    }

    getCompanyAttorney(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/CompanyAttorney`, {
            params: {
                id: id
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getContractionAttorney({limit, skip, sortBy, desc, isActive, ownerInn, q, number, branch}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/ContractionAttorney`, {
            params: {
                skip: skip ? skip : null,
                limit: limit ? limit : null,
                sortBy: typeof sortBy === "string" ? sortBy : "",
                desc: typeof desc === "boolean" ? desc : false,
                isActive: isActive ? isActive : null,
                ownerInn: typeof ownerInn === "string" ? ownerInn : "",
                q: typeof q === "string" ? q : "",
                number: typeof number === "string" ? number : "",
                branch: branch ? branch : null
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    createAttorney({
                       Number,
                       Start,
                       End,
                       Position,
                       Fullname,
                       PersonInn,
                       PassportSerial,
                       PassportNumber,
                       PassportIssuer,
                       PassportIssuedOn,
                       ContractorInn,
                       ContractorName,
                       ContractNumber,
                       ContractDate,
                       Items
                   }, noUpdate) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/CompanyAttorney`, {
            Number: Number,
            Start: moment(Start).format(MOMENT_API_DATE_FORMAT),
            End: moment(End).format(MOMENT_API_DATE_FORMAT),
            Position: Position,
            Fullname: Fullname,
            PersonInn: PersonInn,
            PassportSerial: PassportSerial,
            PassportNumber: PassportNumber,
            PassportIssuer: PassportIssuer,
            PassportIssuedOn: moment(PassportIssuedOn).format(MOMENT_API_DATE_FORMAT),
            ContractorInn: ContractorInn,
            ContractorName: ContractorName,
            ContractNumber: ContractNumber,
            ContractDate: ContractDate ? ContractDate.format(MOMENT_API_DATE_FORMAT) : null,
            Items: _.map(Items, i => {

                let itemQuantity = null;

                if (typeof i.quantity === "string") {
                    itemQuantity = parseInt(i.quantity.replace(/\s/g, ""));
                } else {
                    itemQuantity = +i.quantity;
                }
                return {
                    Product: i.product,
                    Measurement: i.measurement,

                    Quantity: itemQuantity,
                    QuantityInWords: AmountTextHelper.getText(itemQuantity, true)
                }
            })
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        }).then(function (response) {
            if (!noUpdate) {
                $bus.$emit(busEvents.CompanyAttorneyAdded);
            }
        }).catch(function (error) {
            if (error.response) {
                let errorDataBadRequest = [];
                errorDataBadRequest = JSON.parse(error.response.config.data);
                errorDataBadRequest['Status'] = error.response.status;
                errorDataBadRequest['StatusText'] = error.response.statusText;
                return errorDataBadRequest;
            }
        });
    }

    editAttorney({
                     Id,
                     Number,
                     Start,
                     End,
                     Position,
                     Fullname,
                     PersonInn,
                     PassportSerial,
                     PassportNumber,
                     PassportIssuer,
                     PassportIssuedOn,
                     ContractorInn,
                     ContractorName,
                     ContractNumber,
                     ContractDate,
                     Items
                 }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.put(`${APIHOST}/api/CompanyAttorney/${Id}`, {
            Number: Number,
            Start: Start.format(MOMENT_API_DATE_FORMAT),
            End: End.format(MOMENT_API_DATE_FORMAT),
            Position: Position,
            Fullname: Fullname,
            PersonInn: PersonInn,
            PassportSerial: PassportSerial,
            PassportNumber: PassportNumber,
            PassportIssuer: PassportIssuer,
            PassportIssuedOn: PassportIssuedOn.format(MOMENT_API_DATE_FORMAT),
            ContractorInn: ContractorInn,
            ContractorName: ContractorName,
            ContractNumber: ContractNumber,
            ContractDate: ContractDate ? ContractDate.format(MOMENT_API_DATE_FORMAT) : null,
            Items: _.map(Items, i => {
                return {
                    Product: i.product,
                    Measurement: i.measurement,
                    Quantity: +i.quantity,
                    QuantityInWords: AmountTextHelper.getText(i.quantity, true),
                }
            })
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        }).then(function () {
            $bus.$emit(busEvents.CompanyAttorneyEdited);
        }).catch(function () {

        });
    }

    deleteAttorney(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.delete(`${APIHOST}/api/CompanyAttorney/${id}`, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        }).then(function () {
            $bus.$emit(busEvents.CompanyAttorneyDeleted);
        }).catch(function () {

        });
    }

    printPdf(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        const promise = axios.get(`${APIHOST}/api/CompanyAttorneyPdf`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {id: id}
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            PrintJs(url);
        });

        return promise;
    }
}


export default new AttorneyService()
